<app-modal
  class="density-lower"
  title="Visualização do vídeo selecionado"
  [buttons]="false"
>
  <div class="modal-content">
    <app-video-player [videoUrl]="url"></app-video-player>
  </div>
</app-modal>
